<template>
  <div id="stat_alerts_widget">
    <div class="pb-0" style="position:relative;">
      <div class="mb-0 pb-0">
        <div class="container col-12 mb-0" style="margin-top: 0; width: 100% !important;">

          <div class="row panel pt-20 pl-15 pr-15">
            <div class="steps tabs-wrapper mb-20">
              <div class="step disabled-step col-lg-4">
                <span class="step-number">
                  0
                </span>
                <div class="step-desc">
                  <span class="step-title">
                    Запланированные учебные группы
                  </span>
                </div>
              </div>

              <div class="step col-lg-4" :class="{current: active_tab === 1}" @click="active_tab = 1">
                <span v-if="active_groups.error" class="step-number">
                  <i class="fa fa-exclamation-triangle" :class="{blue: active_tab === 1, white: active_tab === 2}" aria-hidden="true"></i>
                </span>

                <span v-if="!active_groups.error && active_groups.loading" class="step-number">
                  <i class="fa fa-spinner fa-pulse" :class="{blue: active_tab === 1, white: active_tab === 2}" aria-hidden="true"></i>
                </span>

                <span v-if="!active_groups.error && !active_groups.loading" class="step-number" :style="active_groups.font_style">
                  {{ active_groups.count }}
                </span>
                <div class="step-desc">
                  <span class="step-title">
                    Активные учебные группы
                  </span>
                </div>
              </div>

              <div class="step col-lg-4" :class="{current: active_tab === 2}" @click="active_tab = 2">
                <span v-if="finished_groups.error" class="step-number">
                  <i class="fa fa-exclamation-triangle" :class="{blue: active_tab === 2, white: active_tab === 1}" aria-hidden="true"></i>
                </span>

                <span v-if="!finished_groups.error && finished_groups.loading" class="step-number">
                  <i class="fa fa-spinner fa-pulse" :class="{blue: active_tab === 2, white: active_tab === 1}" aria-hidden="true"></i>
                </span>

                <span v-if="!finished_groups.error && !finished_groups.loading" class="step-number" :style="finished_groups.font_style">
                  {{ finished_groups.count }}
                </span>
                <div class="step-desc">
                  <span class="step-title">
                    Завершенные учебные группы
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="content-tab-widget" :class="{hidden: active_tab === 2}">
            <div class="row">
              <div class="col-12">
                <top-counts-panel />
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="page-content page-content-widgets my-dashboard" id="graphsBlock">
                  <div id="widgets" class="row">
                    <div class="col-xl-8 col-lg-12 col-xs-12 masonry-item">
                      <div id="DayStatsUsers">
                        <day-stats-users-diagram />
                      </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-xs-12 masonry-item">
                      <div id="HoursStatsUsers">
                        <hours-stats-users-diagram />
                      </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-xs-12 masonry-item">
                      <div id="UserStatsAll">
                        <user-stats-all-diagram />
                      </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-xs-12 masonry-item">
                      <div id="UserProgress">
                        <user-progress-diagram />
                      </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-xs-12 masonry-item">
                      <div id="UserPass">
                        <user-pass-diagram />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="content-tab-widget":class="{hidden: active_tab === 1}">
            <div class="row mb-0">
              <div class="col-lg-6 pl-0 pr-0">
                <div id="DetailsOfReasonsByMonthsChart" class="panel shadow-none mb-20">
                  <details-of-reasons-by-months-diagram :active_tab="active_tab" />
                </div>
              </div>
              <div class="col-lg-6 pl-md-15 pr-0 pl-0 d-flex order-first order-md-last">
                <div>
                  <reasons-detalization-all-time-counts-panel />
                </div>
              </div>
            </div>
          </div>

          <div id="updated-at" class="row" :class="{hidden: updated_at === ''}">
            <div class="col-12">
              <span class="pull-right">
                Данные актуальны на {{ updated_at }}
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopCountsPanel from './TopCountsPanel.vue';
import DayStatsUsersDiagram from './DayStatsUsersDiagram.vue';
import HoursStatsUsersDiagram from './HoursStatsUsersDiagram.vue';
import UserStatsAllDiagram from './UserStatsAllDiagram.vue';
import UserProgressDiagram from './UserProgressDiagram.vue';
import UserPassDiagram from './UserPassDiagram.vue';
import DetailsOfReasonsByMonthsDiagram from './DetailsOfReasonsByMonthsDiagram.vue';
import ReasonsDetalizationAllTimeCountsPanel from './ReasonsDetalizationAllTimeCountsPanel.vue';

export default {
  name: 'HomePage',
  components: {
    TopCountsPanel,
    DayStatsUsersDiagram,
    HoursStatsUsersDiagram,
    UserStatsAllDiagram,
    UserProgressDiagram,
    UserPassDiagram,
    DetailsOfReasonsByMonthsDiagram,
    ReasonsDetalizationAllTimeCountsPanel
  },
  data() {
    return {
      active_groups: {
        loading   : true,
        error     : false,
        count     : 0,
        font_style: '',
      },
      finished_groups: {
        loading   : true,
        error     : false,
        count     : 0,
        font_style: '',
      },
      updated_at: '',
      active_tab: 1
    }
  },
  methods: {
    get_data() {
      axios.get(`/widgets/TabsPanel`).then(response => {
        Object.keys(response.data).map( (key) => {
          this[key].count      = response.data[key];
          this[key].font_style = this.font_size(this[key].count);
          this[key].loading    = false;
        });
      }).catch(error => {
        console.log(error);
        this.active_groups.error = true;
        this.finished_groups.error = true;
      });
    },
    get_updated_date() {
      axios.get(`/widgets/UpdatedAt`).then(response => {
        this.updated_at = response.data.updated_at;
      }).catch(error => {
        console.log(error);
      });
    },
    font_size(content) {
      const len = content.toString().length;

      const styles = {
        4: 'font-size: 14pt !important;',
        5: 'font-size: 11pt !important;',
      };

      return Object.keys(styles).indexOf(len.toString()) !== -1 ? styles[len] : '';
    },
  },
  mounted() {
    this.get_data();
    this.get_updated_date();
  },
};
</script>

<style scoped>
  .tabs-wrapper {
    width: 100%;
    margin-top: 0;
    margin-bottom: 0;
  }

  .fa.blue {
    color: #3f51b5;
  }

  .fa.white {
    color: #ffffff;
  }

  .hidden {
    display: none;
  }

  #graphsBlock {
    padding-bottom: 0;
  }

  #updated-at {
    margin-bottom: 30px;
  }
</style>
